import { cn, tv } from "@pcln/horizon";
const carFormVariants = {
    differentDropOff: {
        gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] @7xl:grid-cols-[minmax(0,0.4fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_minmax(0,0.3fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-sm @3xl:col-span-2 col-span-full @7xl:order-last',
        submitInput: 'col-span-2 @7xl:[grid-area:unset]'
    },
    sameDropOff: {
        gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)] @7xl:grid-cols-[minmax(0,0.8fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_minmax(0,0.4fr)_minmax(0,0.3fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-sm @3xl:col-span-2 col-span-full @7xl:order-last',
        submitInput: 'col-span-2 @7xl:[grid-area:unset]'
    },
    hotelOnly: {
        gridContainer: 'grid-cols-2 @7xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-sm @3xl:col-span-2 col-span-full @7xl:order-last',
        submitInput: 'col-span-2 @7xl:[grid-area:unset]'
    },
    withFlight: {
        gridContainer: 'grid-cols-2 @7xl:grid-cols-[minmax(0,0.9fr)_minmax(0,0.9fr)_minmax(0,0.8fr)_minmax(0,0.7fr)_max-content]',
        pickupInput: 'col-span-full @7xl:[grid-area:unset]',
        dualPickupInput: 'col-span-2 @7xl:[grid-area:unset]',
        dropoffInput: 'col-span-2 @7xl:[grid-area:unset]',
        packageInput: 'flex flex-row items-center justify-start gap-4 text-sm @3xl:col-span-2 col-span-full @7xl:order-last',
        submitInput: 'col-span-2 @7xl:[grid-area:unset]'
    },
    differentDropOffCompact: {
        gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)]',
        pickupInput: 'col-span-full',
        dualPickupInput: 'col-span-2',
        dropoffInput: 'col-span-2',
        packageInput: 'text-sm @3xl:col-span-2 col-span-full',
        submitInput: 'col-span-2'
    },
    sameDropOffCompact: {
        gridContainer: 'grid-cols-[minmax(0,1fr)_minmax(0,1fr)] @3xl:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)]',
        pickupInput: 'col-span-full',
        dualPickupInput: 'col-span-2',
        dropoffInput: 'col-span-2',
        packageInput: 'text-sm @3xl:col-span-2 col-span-full',
        submitInput: 'col-span-2'
    },
    hotelOnlyCompact: {
        gridContainer: 'grid-cols-2',
        pickupInput: 'col-span-full',
        dualPickupInput: 'col-span-2',
        dropoffInput: 'col-span-2',
        packageInput: 'text-sm col-span-full @3xl:col-span-1',
        submitInput: 'col-span-full @3xl:col-span-1'
    },
    withFlightCompact: {
        gridContainer: 'grid-cols-2',
        pickupInput: 'col-span-full',
        dualPickupInput: 'col-span-2',
        dropoffInput: 'col-span-2',
        packageInput: 'text-sm col-span-full @3xl:col-span-1',
        submitInput: 'col-span-full @3xl:col-span-1'
    }
};
const carFormSlots = {
    gridContainer: 'grid grid-cols-1 gap-3 items-center mx-auto',
    optionsWrapper: 'col-span-full @7xl:order-first',
    pickupInput: '',
    dualPickupInput: '',
    dropoffInput: '',
    packageInput: '',
    submitInput: '',
    datePickerWrapper: '',
    packageDatePickerWrapper: 'col-span-full @3xl:col-span-1',
    flightInput: 'col-span-full @3xl:[grid-area:unset]'
};
const horizonCarForm = tv({
    slots: carFormSlots,
    variants: {
        carType: carFormVariants
    },
    defaultVariants: {
        carType: 'sameDropOff'
    }
});
const getCarVariant = (isDifferentDropOff, isHotel, isFlight, variant)=>{
    const isCompact = 'compact' === variant;
    if (isCompact) {
        if (isFlight) return 'withFlightCompact';
        if (isHotel) return 'hotelOnlyCompact';
        if (isDifferentDropOff) return 'differentDropOffCompact';
        return 'sameDropOffCompact';
    }
    if (isFlight) return 'withFlight';
    if (isHotel) return 'hotelOnly';
    if (isDifferentDropOff) return 'differentDropOff';
    return 'sameDropOff';
};
const getGridContainerClass = (isDifferentDropOff = false, isHotel = false, isFlight = false, variant = 'full')=>{
    const carVariant = getCarVariant(isDifferentDropOff, isHotel, isFlight, variant);
    const styles = horizonCarForm({
        carType: carVariant
    });
    return cn(styles.gridContainer());
};
const getInputClass = (type, isDifferentDropOff = false, isHotel = false, isFlight = false, variant = 'full')=>{
    if ('datePickerWrapper' === type) return carFormSlots.datePickerWrapper;
    if ('packageDatePickerWrapper' === type) return carFormSlots.packageDatePickerWrapper;
    if ('flightInput' === type) return carFormSlots.flightInput;
    const carVariant = getCarVariant(isDifferentDropOff, isHotel, isFlight, variant);
    const styles = horizonCarForm({
        carType: carVariant
    });
    switch(type){
        case 'pickup':
            return isDifferentDropOff ? styles.dualPickupInput() : styles.pickupInput();
        case 'options':
            return styles.optionsWrapper();
        case 'dropoff':
            return styles.dropoffInput();
        case 'package':
            return styles.packageInput();
        case 'submit':
            return styles.submitInput();
        default:
            return '';
    }
};
export { getGridContainerClass, getInputClass, horizonCarForm };
